import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "hooks/LocalStorage";
import { IMenuItem } from "Dashboard/domain/IMenuItem";
import ToolTip from "components/Tooltip";
// import ReportsTooltip from "./ReportsTooltip";
import ReportsTooltip from "../../Dashboard/scenes/Reports/Index";
// import ChatTooltip from "./ChatTooltip";
import ChatTooltip from "../../Dashboard/scenes/Chat/Index";
// import RequirementsTooltip from "./RequirementsTooltip";
import Requisitions from "../../Dashboard/scenes/Requisitions/Index";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectState } from "Dashboard/dashboard.slice";
import { REQUISITION_WAREHOUSE_MODULE_NAME } from "Dashboard/scenes/Requisitions/domain/RequisitionsModule";

const findIndex = (items: IMenuItem[]) => {
  const index = items.findIndex((item) => item.disabled === false);
  return index > 0 ? index : 0;
};

const getToolTip = (module: string) => {
  switch (module) {
    case "chat":
      return ChatTooltip;
    case REQUISITION_WAREHOUSE_MODULE_NAME:
      return Requisitions;
    case "report":
      return ReportsTooltip;
    default:
      return () => {
        return null;
      };
  }
};

interface IProps {
  groupId: string;
  hasNotification?: boolean;
  items: IMenuItem[];
  hasTooltip?: boolean;
}

const MenuGroup = (props: IProps) => {
  const navigate = useNavigate();
  let { groupId, hasNotification, items, hasTooltip } = props;
  const [storedValue, setValue] = useLocalStorage(groupId, findIndex(items));
  const { unseenMessagesCount } = useSelector(selectState);
  const { requisitionsCount } = useSelector(selectState);
  const { unseenReportsCount } = useSelector(selectState);
  const [arrNotifications, setArrNotifications] = useState<number[]>([]);

  const onClick = () => {
    navigate(items[storedValue].path);
  };

  useEffect(() => {
    setArrNotifications(
      [unseenMessagesCount, requisitionsCount, unseenReportsCount]
    );
  }, [unseenMessagesCount, requisitionsCount, unseenReportsCount])

  let disabled = items[storedValue].disabled;

  return (
    <div className="menu-group">
      {!hasTooltip && (
        <img
          src={items[storedValue].icon}
          className={disabled ? "disabled" : ""}
          alt="img"
          onClick={disabled ? () => undefined : onClick}
        />
      )}
      {hasTooltip && (
        <ToolTip
          content={getToolTip(items[storedValue].module)}
          direction="right"
          delay={1}
          style={{ top: "100px", left: "80px" }}
          arrowStyle={{ top: "37%" }}
          title={items[storedValue].title}
        >
          {(showTip: Function) => (
            <img
              src={items[storedValue].icon}
              className={disabled ? "disabled" : ""}
              alt="img"
              onClick={disabled ? () => undefined : () => showTip()}
            />
          )}
        </ToolTip>
      )}
      {items.map((item: any, index: number) => (
        <div key={index} className={`menu-item-row ${item.disabled} ? "disabled" : ""`}>
          {((hasNotification && arrNotifications[index] > 0)
            && <span className="badge">{arrNotifications[index]}</span>)
            || ((hasNotification && arrNotifications[index] <= 0)
              && <span className="no-notification"></span>)}
          <input
            type="radio"
            name={groupId}
            value={index}
            style={!item.disabled ? { cursor: "pointer" } : undefined}
            checked={index === parseInt(storedValue)}
            onChange={(e) => setValue(parseInt(e.target.value))}
            disabled={item.disabled}
            id={item.menuItemId}
          />
          <label htmlFor={item.menuItemId}
            style={!item.disabled ? { cursor: "pointer" } : undefined}>
            {item.title}
          </label>
          <br />
        </div>
      ))}
    </div>
  );
};

export default MenuGroup;
